import React from "react";
import { cn } from "@/lib/utils";

export function Iniciales({ nombre, size = 26, className }) {
  const ini = (nombre || "?").trim().split(/\s+/).slice(0, 2).map((p) => p[0]).join("").toUpperCase();
  return (
    <span
      className={cn("inline-flex items-center justify-center rounded-lg bg-[#ECE8E0] font-display font-bold text-ink shrink-0", className)}
      style={{ width: size, height: size, fontSize: size > 30 ? 15 : 11.5 }}
    >{ini}</span>
  );
}

export function PageHeader({ titulo, subtitulo, acciones, className }) {
  return (
    <div className={cn("flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-5", className)}>
      <div className="min-w-0">
        <h1 className="font-display font-bold text-[26px] lg:text-[30px] leading-[1.05] text-navy-2" data-testid="page-title">{titulo}</h1>
        {subtitulo && <p className="text-ink-3 mt-1.5 text-[15px]">{subtitulo}</p>}
      </div>
      {acciones && <div className="flex items-center gap-2 flex-wrap sm:justify-end">{acciones}</div>}
    </div>
  );
}

export function SectionCard({ titulo, descripcion, eyebrow = true, children, className, acciones, ...rest }) {
  return (
    <section className={cn("bg-surface border border-line rounded-xl p-4 lg:p-5", className)} {...rest}>
      {(titulo || acciones) && (
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="min-w-0">
            {titulo && (eyebrow ? <h2 className="eyebrow">{titulo}</h2> : <h2 className="font-display font-semibold text-[18px] text-navy-2">{titulo}</h2>)}
            {descripcion && <p className="text-[13.5px] text-ink-3 mt-1">{descripcion}</p>}
          </div>
          {acciones}
        </div>
      )}
      {children}
    </section>
  );
}

export function EmptyState({ icon: Icon, texto, accion, className }) {
  return (
    <div className={cn("flex flex-col items-center text-center py-10 px-4", className)} data-testid="empty-state">
      <svg width="96" height="56" viewBox="0 0 96 56" fill="none" stroke="#D3CDC2" strokeWidth="1.5" className="mb-4" aria-hidden="true">
        <rect x="6" y="28" width="40" height="22" rx="2" /><rect x="50" y="28" width="40" height="22" rx="2" /><rect x="28" y="4" width="40" height="22" rx="2" />
        <path d="M14 28v22M22 28v22M30 28v22M38 28v22M58 28v22M66 28v22M74 28v22M82 28v22M36 4v22M44 4v22M52 4v22M60 4v22" />
      </svg>
      {Icon && <Icon className="h-8 w-8 text-ink-3 mb-2" strokeWidth={1.5} />}
      <p className="text-ink-2 text-[15px] max-w-xs">{texto}</p>
      {accion && <div className="mt-4">{accion}</div>}
    </div>
  );
}
